import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getUserProfile = async () => {
  const { data: session } = await supabase.auth.getSession()

  if (!session?.session?.user.id) {
    return null
  }

  const { data, error } = await supabase
    .from('user_profiles')
    .select(`
      *,
      expertProfile:salons_profile (*),
      privacy:profile_privacy_activity (id, activity, enabled)
    `)
    .eq('id', session?.session?.user.id)
    .maybeSingle();

  if (error) {
    throw new Error(error.message)
  }

  if (!data) {
    return null
  }

  // @ts-ignore
  data.isVerifiedExpert = Boolean(data.expert_id)

  return data
}

export default function useUser(isAuth: boolean = true) {
  return useQuery({
    queryKey: ['profile'],
    staleTime: 1000,
    queryFn: () => getUserProfile()
  })
}
